module.exports = __webpack_public_path__ + "static/media/external_env_2_media_4.9e0e9340.webp";